export default __webpack_public_path__ + "static/media/impressora-argox.a1dde11c.png";